var __jsx = React.createElement;
import { cn } from "@lib/cn";
import Icons from "@modules/icons";
import { useTranslations } from "next-intl";
import React from "react";
export const CabinDetailBase = _ref => {
  let {
    color,
    cabin,
    className
  } = _ref;
  const t = useTranslations('Flights');
  return __jsx("div", {
    className: "flex flex-row items-center gap-2"
  }, __jsx(Icons.starFilled, {
    color: color
  }), __jsx("p", {
    className: cn("h-fit", color ? "text-".concat(color) : undefined, className)
  }, t("CABIN_CLASS.".concat(cabin))));
};
export default CabinDetailBase;